<template>
  <div v-if="isLoaded">

    <!--    <transition name="fade">-->
    <!--      <div class="row" v-if="moduleInfoMessage">-->
    <!--        <div class="col-12">-->
    <!--          <div style="-->
    <!--                color: rgb(90, 90, 90);-->
    <!--                font-size: 16px;-->
    <!--                padding: 10px;-->
    <!--                background: #F8F8F8;-->
    <!--                border: 1px solid rgb(90, 90, 90);-->
    <!--                margin-bottom: 20px;-->
    <!--                border-radius: 3px">-->
    <!--            {{ moduleInfoMessage }}-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </transition>-->

    <transition name="fade">
      <div class="row" v-if="unitsErrorMessage || terminErrorMessage || moduleUnitsErrorMessage">
        <div class="col-12">
          <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
            {{ unitsErrorMessage }} {{ terminErrorMessage }} {{ moduleUnitsErrorMessage }}
          </div>
        </div>
      </div>
    </transition>

    <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
      <div class="col text-end" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
      <div class="col-auto text-end">
        <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
      </div>
    </div>

    <form @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
          <Datepicker
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              v-model="formData.termin"
              :required="true"
              label="Termin"
              position="down"
              :validation="v$.termin"
              :messages="v$.termin.required.$message"
              @update:modelValue="onChangeTermin"/>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12  ">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                  v-model="formData.startTime"
                  :required="true"
                  :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                  label="Startzeit"/>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                  v-model="formData.endTime"
                  :required="true"
                  :minutesArray='["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]'
                  label="Endzeit"/>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue v-model="formData.presence"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="presenceDropdown"
                     :required="true"
                     label="Anwesenheit"
                     placeholder="Wählen Sie Anwesenheit"
                     :validation="v$.presence"
                     :messages="v$.presence.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseCheckbox
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              v-model="formData.overwrite"
              label="Überschreiben"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseNumber
              v-model="formData.units"
              label="Einheiten"
              disabled="disabled"/>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <SelectVue v-model="formData.coachType"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="coachTypeDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Coachart"
                     placeholder="Wählen Sie Coachart"
                     :validation="v$.coachType"
                     :messages="v$.coachType.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                v-model="formData.signature"
                label="Unterschrift"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class="mt-4">
            <BaseCheckbox
                :disabled="isBilled || isSystemAddedMeeting"
                v-model="formData.billed"
                label="Abgerechnet"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <div class=" mt-4">
            <BaseCheckbox
                :disabled="isSystemAddedMeeting || isCoachBilled"
                v-model="formData.paid"
                label="Bezahlt"
                :labelPosition="'right'"/>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <div class="mt-4">
            <BaseCheckbox
                :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                v-model="formData.homeVisit"
                label="Hausbesuch"
                :labelPosition="'right'"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-8 col-sm-12">
          <SelectVue v-model="formData.moduleId"
                     :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
                     :options="moduleDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Modul"
                     placeholder="Modul auswählen"
                     :validation="v$.moduleId"
                     :messages="v$.moduleId.required.$message"
                     @update:modelValue="onChangeModule"/>
        </div>
        <div v-if="(currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') && protocolId"
             class="col-lg-2 col-md-4 col-sm-12">
          <BaseNumber
              v-model="formData.sectionNumber"
              :validation="v$.sectionNumber"
              :messages="v$.sectionNumber?.required?.$message"
              :label="$t('general.section_number')"
              :disabled="!updateAsAdmin"/>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12"
             v-if="
                 ( currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_ACCOUNTANT') && !originalIsSystemAddedMeeting">
          <SelectVue v-model="formData.coachId"
                     :disabled="isCoachBilled"
                     :options="coachDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Coach"
                     placeholder="Trainer auswählen"/>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <h6>Einschränkung</h6>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <BaseInput v-model="formData.meetingTopic"
                     label="Sitzungsthema"
                     :required="true"
                     :validation="v$.meetingTopic"
                     :messages="v$.meetingTopic.required.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <TextEditor
              v-model="formData.description"
              @update:model-value="formData.description = $event"
              :inputStyle="{ height: '200px' }"
              label="Beschreibung"/>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 d-flex justify-content-end">
          <BaseCheckbox
              v-model="formData.geva"
              :disabled="isBilled || isCoachBilled || isSystemAddedMeeting"
              label="Geva-Potentialanalyse"
              :labelPosition="'right'"/>
        </div>
      </div>

      <div v-if="!unitsErrorMessage && !terminErrorMessage && !moduleUnitsErrorMessage"
           class="d-flex justify-content-center w-100 mt-3">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import dropdownService from '@/api/Dropdown';
import portalPrivateCoachingService from '@/api/Portal/PrivateCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {addDeletedCoachToDropdown, addDeletedModuleToDropdown} from '@/shared/portal/commonFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import BaseToggle from "@/components/base/BaseToggle.vue";
import {portalPrivateCoachingCheckModule} from "@/shared/portal/privateCoachingFunctions";
import SaveButton from '@/components/button/SaveButton.vue';

const micNewUnitsCalculationStartFrom = process.env.VUE_APP_MIC_NEW_UNITS_CALCULATION_START_FROM
const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const coachDropdown = ref([]);
const presenceDropdown = ref([]);
const coachTypeDropdown = ref([]);
const moduleDropdown = ref([]);
const unitsErrorMessage = ref('');
const terminErrorMessage = ref('');
const moduleInfoMessage = ref('');
const moduleUnitsErrorMessage = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);
const isSystemAddedMeeting = ref(false);
const updateAsAdmin = ref(false)
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic
const originalIsSystemAddedMeeting = ref(false) // Need this for update as admin logic

const props = defineProps({
  coachingId: {
    type: Number,
    required: true,
  },
  protocolId: {
    type: [Number, String],
    required: true,
  },
  operationType: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const coachingId = toRefs(props)['coachingId'];
const protocolId = toRefs(props)['protocolId'];
const operationType = toRefs(props)['operationType'];

const formData = ref({
  coachingId: '',
  operationType: '',
  termin: '',
  startTime: '00:00',
  endTime: '00:00',
  presence: '',
  coachType: '',
  overwrite: false,
  units: 0,
  signature: false,
  billed: false,
  paid: false,
  homeVisit: false,
  coachId: null,
  moduleId: null,
  sectionNumber: null,
  geva: false,
  meetingTopic: '',
  description: '',
});

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  coachType: requiredRule(t),
  units: requiredRule(t),
  meetingTopic: requiredRule(t),
  moduleId: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId.value;
    formData.value.operationType = operationType.value;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer

    if (props.protocolId) {
      if (updateAsAdmin.value) {
        await portalPrivateCoachingService.updateUpdateAsAdminMICProtocol(formData.value, +protocolId.value);
      } else {
        await portalPrivateCoachingService.updateMICProtocol(formData.value, +protocolId.value);
      }
    } else {
      await portalPrivateCoachingService.postMICProtocol(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getProtocolData(protocolId) {
  try {
    const {data} = await portalPrivateCoachingService.getProtocolData(protocolId.value);
    const {protocol} = data?.data;
    const coachId = protocol.id;

    isBilled.value = protocol.invoiced;
    isCoachBilled.value = protocol.coachInvoiced;
    isSystemAddedMeeting.value = protocol.systemAddedMeeting;

    // Save original values
    originalIsBilled.value = protocol.invoiced;
    originalIsCoachBilled.value = protocol.coachInvoiced;
    originalIsSystemAddedMeeting.value = protocol.systemAddedMeeting

    addDeletedCoachToDropdown(protocol.coach, coachDropdown);
    addDeletedModuleToDropdown(protocol.module, moduleDropdown);

    formData.value = {
      ...protocol,
      coachId: coachId,
      moduleId: protocol.module?.id,
    };
  } catch (error) {
    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    await ErrorToast(error);
  }
}

async function getAssignedCoachesForDropdown(coachingId) {
  try {
    CloseToast();
    const {data} = await dropdownService.getPrivateCoachingAssignedCoaches(+coachingId);

    coachDropdown.value = data.data.map(item => ({
      label: `${item.firstName}` + ' ' + `${item.lastName}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getAssignedModulesForDropdown(privateCoachingId) {
  try {
    CloseToast();
    const {data} = await dropdownService.getPrivateCoachingAssignedModules(+privateCoachingId);
    moduleDropdown.value = data.data.map(item => ({
      label: `${item.name}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

const calculateTimeDifference = () => {
  if (formData.value.startTime && formData.value.endTime) {
    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const diffMinutes = endTotalMinutes - startTotalMinutes;
    let units = (diffMinutes / 45).toPrecision(3).substring(0, 4);

    onChangeUnits(units);

    if (Number.isInteger(parseFloat(units))) { // Only if is rounded number
      let unitDuration = 45;
      if (operationType.value === 'bgm_60') {
        unitDuration = 60;
      }

      // Check a presence type
      if ((formData.value.presence)) {
        if (formData.value.presence === 'anwesend') {
          units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
        } else {
          units = 1;
        }
      }

      // If presenceType is selected and overview is true, calculate units
      if (formData.value.overwrite === true) {
        units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);
      }

      onChangeModule(formData.value.moduleId);
    }

    formData.value.units = Number(units).toFixed(2);
  } else {
    formData.value.units = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (operationType.value === 'compass') { // only one unit per meeting
    if (parsedValue !== 1) {
      unitsErrorMessage.value = 'Die Besprechungsdauer muss 45 Minuten betragen.';
    } else {
      unitsErrorMessage.value = '';
    }
  } else {
    if (isNaN(parsedValue) || parsedValue <= 0) {
      unitsErrorMessage.value = 'Einheiten müssen runde Zahlen sein, die größer als 0 sind.';
    } else if (!Number.isInteger(parsedValue)) {
      unitsErrorMessage.value = 'Die Anzahl der Einheiten muss eine runde Zahl sein..';
    } else {
      unitsErrorMessage.value = '';
    }
  }
}

async function onChangeTermin(newTermin) {
  // Only for compass
  if (operationType.value === 'compass') {

    const {data} = await portalPrivateCoachingService.getCompassDateRange(
        coachingId, protocolId,
    );

    const startDate = data.data.startDateRange;
    const endDate = data.data.endDateRange;

    // Convert date strings to Date objects
    const parseDate = (dateString) => {
      const [day, month, year] = dateString.split('.');
      return new Date(`${year}-${month}-${day}`);
    };

    const start = parseDate(startDate);
    const end = parseDate(endDate);
    const termin = parseDate(newTermin);

    // Check if newTermin is in the range
    const isInRange = termin >= start && termin <= end;

    if (isInRange) {
      terminErrorMessage.value = '';
    } else {
      terminErrorMessage.value = 'Das Sitzungsprotokoll, welches neu angelegt wird, muss im Zeitraum vom ' +
          startDate + ' bis ' + endDate + ' liegen.';
    }
  }
}

async function onChangeModule(newValue) {
  try {
    if (newValue) {
      const {data} = await portalPrivateCoachingService.getSumUnitsDoneForModule(
          +coachingId.value,
          +newValue,
          protocolId.value,
      );

      const [errorMessage, infoMessage] = portalPrivateCoachingCheckModule(data, formData, updateAsAdmin.value);

      moduleInfoMessage.value = infoMessage;
      moduleUnitsErrorMessage.value = errorMessage;
    } else {
      moduleInfoMessage.value = '';
      moduleUnitsErrorMessage.value = '';
    }
  } catch (error) {
    console.log(error)
    await ErrorToast(error);
  }
}


watch(
    () => [
      formData.value.startTime,
      formData.value.endTime,
      formData.value.presence,
      formData.value.overwrite,
    ],
    calculateTimeDifference,
);

async function getEnumsDropdown() {
  presenceDropdown.value = getEnums?.value?.presenceTypes || [];
  coachTypeDropdown.value = getEnums?.value?.portalCoachTypes || [];
}


function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;
    isSystemAddedMeeting.value = false;

    formRules.value = {
      ...formRules.value,
      sectionNumber: requiredRule(t),
    }

    if (originalIsSystemAddedMeeting.value === true) {
      formRules.value = {
        ...formRules.value,
        moduleGoal1Id: '',
        moduleGoal2Id: '',
        moduleGoal3Id: '',
        moduleGoal4Id: '',
      }
    }
  } else {
    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;
    isSystemAddedMeeting.value = originalIsSystemAddedMeeting.value

    formRules.value = {
      ...formRules.value,
      sectionNumber: '',
    }
  }
}

const showUpdateAsAdminButton = computed(() => {
  if (
      (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
      protocolId.value != null && protocolId.value !== ''
      // (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
      // (originalIsBilled.value || originalIsCoachBilled.value || originalIsSystemAddedMeeting.value)
  ) {
    return true;
  }

  return false;
})

onMounted(async () => {
  await Promise.all([
    getAssignedCoachesForDropdown(+coachingId.value),
    getAssignedCoachesForDropdown(+coachingId.value),
    getAssignedModulesForDropdown(+coachingId.value),
    getEnumsDropdown(),
  ]);

  if (protocolId.value) {
    await getProtocolData(protocolId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>